<div
  class="dev-warning"
  [class.in-space]="router.url.includes('/spaces/')"
  [ngClass]="{
    'min-height':
      (isExpanded$ | async) &&
      ((isCustomFlagsEnabled$ | async) || (this.customServeUrls | keyvalue)?.length)
  }"
>
  <div [hidden]="(isExpanded$ | async) === false" class="dynamic-url-warning">
    <div class="text _flags" *ngIf="isCustomFlagsEnabled$ | async">custom flags active</div>
    <div class="text _servers" *ngIf="(this.customServeUrls | keyvalue)?.length">
      <div>custom servers active:</div>
      <div
        *ngFor="let customServerUrlItem of customServeUrls | keyvalue; let i = index"
        class="tooltips"
        [appTooltip]="customServerUrlItem.value"
      >
        <a target="_blank" rel="noopener noreferrer" [href]="customServerUrlItem.value">{{
          customServerUrlItem.key
        }}</a>
      </div>
    </div>
    <div class="end">
      <button *ngIf="(this.customServeUrls | keyvalue)?.length" (click)="resetServerUrl()">
        Reset Servers
      </button>
      <button *ngIf="isCustomFlagsEnabled$ | async" (click)="resetFlags()">Reset Flags</button>
    </div>
  </div>
</div>

<app-pencil-icon
  *ngIf="(this.customServeUrls | keyvalue)?.length || (isCustomFlagsEnabled$ | async)"
  (click)="toggleExpand()"
  [name]="(isExpanded$ | async) ? 'close' : 'code'"
  type="mat-icon"
></app-pencil-icon>
